import React from "react";
import Iaa1 from "../../images/cow (2).png";
import Iaa2 from "../../images/mushrooms.png";
import Iaa3 from "../../images/IAA3.png";
import Iaa4 from "../../images/tree-silhouette.png";
import { Row, Col } from "react-bootstrap";
import "./IAABlock.css";
import {Button} from "@material-ui/core";

export default function IAAProducer({ producers }) {
  const Image = [
    { img: Iaa3, href: "/#Bee" },
    { img: Iaa1 },
    { img: Iaa2 },
    { img: Iaa4 },
  ];
  return (
    
    <>
      {!producers ? (
        <div className="Iaa-container Iaa-container--mod mb-5">
          <h2 className="text-center mb-4">IAA managed by Agri-MSMEs</h2>

          <Row className="justify-content-center">
            {Image.map((e) => {
              return (
                <Col md={3} className="md-md-0 mb-3">
                  <a href={e.href}>
                    <div
                      className={`${
                        e.href
                          ? "imageHover Iaa-Cards d-flex justify-content-center align-items-center"
                          : "Iaa-Cards d-flex justify-content-center align-items-center card-deactivated"
                      }`}
                    >
                      {" "}
                      <img
                        className={`${e.href && "imgCursor"}`}
                        src={e.img}
                        alt="icon"
                      />
                    </div>
                  </a>
                </Col>
              );
            })}
          </Row>
        </div>
      ) : (
        <div className="Iaa-container Iaa-container--mod mb-5">
          <h2 className="text-center mb-0"> </h2>
          <Row className="justify-content-center">
            {Image.map((e) => {
              return (
                <Col md={3} className="md-md-0 mb-3">
                  
                    <div
                      // className={`${
                      //   e.href
                      //     ? "imageHover Iaa-Cards d-flex justify-content-center align-items-center"
                      //     : "Iaa-Cards d-flex justify-content-center align-items-center card-deactivated"
                      // }`}

                      className=" Iaa-Cards d-flex justify-content-center align-items-center"
                    >
                      {" "}
                      <img
                        // className={`${e.href && "imgCursor"}`}
                        src={e.img}
                        alt="icon"
                      />
                    </div>
                  
                </Col>
              );
            })}
          </Row>

          <Button variant="contained" color="primary">
          <a href="http://cbn.gbrapp.com/" target="_blank" rel ="noopener noreferrer">Join </a>
        </Button>
        </div>
      )}
    </>
  );
}
